__turbopack_context__.v({
  "contentWrapper": "g9vENa_contentWrapper",
  "sectionContainer": "g9vENa_sectionContainer",
  "sectionTitle": "g9vENa_sectionTitle",
  "step": "g9vENa_step",
  "stepContent": "g9vENa_stepContent",
  "stepHeader": "g9vENa_stepHeader",
  "stepNumber": "g9vENa_stepNumber",
  "stepTitle": "g9vENa_stepTitle",
  "stepsWrapper": "g9vENa_stepsWrapper",
});
